import React, { useContext } from 'react';
import moment from 'moment-timezone';

import LabelValue from '../../Fields/LabelValue/LabelValue';
import ErrorMessage from '../../modals/ErrorMessage/ErrorMessage';
import FormEdit from '../../Form/FormEdit/FormEdit';
import utils from '../../../services/utils';
import Context from '../../../store/context';
import { formTypes } from '../../../store/catalogs/forms';
import ButtonEdit from '../../Buttons/ButtonEdit/ButtonEdit';

import classes from './CardForm.module.scss';
import { documentTypesAbbreviationsObject } from '../../../store/catalogs/documentTypes';

const CardForm = ({
  className,
  acceptForm,
  categoryKey,
  subtitle,
  subtitleMobile,
  fields,
  backFormvalues,
  schemaValidation,
  onChange,
  optionsLabel,
  isFormResume,
  initialFormValues,
  name,
  isEditable = true
}) => {
  const {
    modal: { showModal }
  } = useContext(Context);

  const editHandler = () => {
    showModal(
      <FormEdit
        className={classes['fields-edit']}
        onAccept={acceptForm}
        onChange={onChange}
        schema={schemaValidation}
        fields={fields}
        backendValues={backFormvalues}
        subtitle={subtitle}
        initialFormValues={initialFormValues}
      />
    );
  };

  return (
    <div key={categoryKey} className={`${className} `}>
      <div className={`${classes['resume-description']} ${!!subtitle ? classes.title : ''} `}>
        <span className={`${classes.subtitle} semibold-18`}>{subtitle}</span>
        <span className={`${classes.subtitleMobile} semibold-18`}>{subtitleMobile}</span>
        {isEditable && (
          /*  <Button Icon={PencilWrite} custom='quaternary' name={name} onClick={editHandler}>
              Editar<span cl>información</span>
            </Button> */
          <ButtonEdit textModule='información' onClick={editHandler} name={name} />
        )}
      </div>
      <div className={classes['div-fields']}>
        {fields
          .filter(item => (!!item.show ? item.show(backFormvalues) : true))
          .map(({ key, keyIndicative, keyType, type, label, list }) => {
            let value = !!optionsLabel[key]
              ? optionsLabel[key][backFormvalues[key]]
              : !!backFormvalues[key]
              ? backFormvalues[key]
              : '';
            if (type === formTypes.date) {
              value = !!value ? (moment(value).isValid() ? moment(value).format('DD/MM/YYYY') : moment().format('DD/MM/YYYY')) : '-';
            } else if (type === formTypes.money) {
              value = utils.moneyFormat(Math.round(value ? value : 0));
            } else if (type === formTypes.switch) {
              value = backFormvalues[key] ? 'Activo' : 'No activo';
            } else if (type === formTypes.radio) {
              value = backFormvalues[key] === 'yes' ? 'Si' : 'No';
            } else if (type === formTypes.password) {
              value = backFormvalues[key] ? '****' : '';
            } else if (type === formTypes.phone) {
              const indicative = backFormvalues[keyIndicative] || '';
              const phone = backFormvalues[key] || '';
              value = (indicative && phone) ? `${indicative} ${phone}` : '';
            } else if (type === formTypes.checkbox) {
              value = list.reduce((prev, item) => prev + ` ${item}`, '');
            } else if (type === formTypes.identification) {
              const typeId = backFormvalues[keyType] ? documentTypesAbbreviationsObject[backFormvalues[keyType]] : '';
              const numberId = backFormvalues[key] || '';
              value = (typeId && numberId) ? `${typeId} - ${numberId}` : '';
            }

            return (
              <LabelValue key={key} classValue={classes['label-value']} name={key} label={label} value={value}>
                {isFormResume && <ErrorMessage name={key} component='div' className='formik-red-color' />}
              </LabelValue>
            );
          })}
      </div>
    </div>
  );
};

export default CardForm;
